import {
  Context,
  ContextType,
} from 'frontend-container/components/Menu/components/Context/context';

import { LoginService } from '@ac/library-utils/dist/services';
import { isValidIpAddress } from '@ac/library-utils/dist/utils';

export enum RegionChangeQueryParam {
  PROPERTY_ID = 'newPropertyId',
  CRO_ID = 'newCentralReservationOfficeId',
}

export const contextTypeRegionChangeQueryParamMapper = (
  context: Context
): RegionChangeQueryParam => {
  switch (context.type) {
    case ContextType.PROPERTY:
      return RegionChangeQueryParam.PROPERTY_ID;
    case ContextType.CRO:
      return RegionChangeQueryParam.CRO_ID;
  }
};

const getRelativeUrlWithContextParam = (
  customPathname?: string,
  context?: Context
): string => {
  const basePath = customPathname || window.location.pathname;

  return getUrlWithContextParam(
    `${basePath}${window.location.search}`,
    context
  );
};

export const getUrlWithContextParam = (
  url: string,
  context?: Context
): string => {
  const [fullPath, queryString] = url.split('?');
  const searchParams = new URLSearchParams(queryString);

  if (context && context.id) {
    searchParams.set(
      contextTypeRegionChangeQueryParamMapper(context),
      context.id
    );
  }

  const newQueryString = searchParams.toString();
  const newUrl = `${fullPath}${newQueryString ? `?${newQueryString}` : ''}`;

  return newUrl;
};

const getContainerName = (regionCode: string): string => {
  const domain = LoginService.domain();

  return domain === 'localhost' || (domain && isValidIpAddress(domain))
    ? 'https://web'
    : `https://${regionCode ? regionCode.toLowerCase() + '.' : ''}web`;
};

export const getOriginForNewRegion = (
  regionCode: string,
  domain: string
): string => `${getContainerName(regionCode)}.${domain}`;

export const getUrlForNewRegion = (
  regionCode: string,
  domain: string,
  context?: Context,
  customPathname?: string
): string =>
  `${getOriginForNewRegion(regionCode, domain)}${getRelativeUrlWithContextParam(
    customPathname,
    context
  )}`;
